var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "23px",
    viewBox: "0 0 17 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location-Pin",
    fill: "#393939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8368979,4.61365228 C17.2350556,7.30445906 17.0172898,10.3962502 15.2541341,12.8565007 L8.50054014,22.2881394 L7.89072919,21.436709 L1.74541042,12.8564912 C-0.0168716144,10.3953196 -0.235052615,7.30358984 1.16281425,4.61334321 C2.51499799,2.01656576 5.10331198,0.387029242 8.07226459,0.259797048 C8.3554051,0.246734317 8.64553715,0.246734317 8.92622527,0.259687928 C11.897913,0.387041357 14.4862307,2.01684313 15.8368979,4.61365228 Z M8.85954845,1.75820325 C8.62246959,1.74726558 8.37847266,1.74726558 8.13894141,1.75831237 C5.70054163,1.86281143 3.59645452,3.18749105 2.49355184,5.30554045 C1.35615247,7.49450825 1.5316529,9.9814338 2.96494788,11.983148 L8.50040211,19.7118606 L14.0347297,11.9829717 C15.4686611,9.98211007 15.6438316,7.49545834 14.5060703,5.30567676 C13.404298,3.18751261 11.3004721,1.8628145 8.85954845,1.75820325 Z",
    id: "Stroke-1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,8 C10,8.552 9.552,9 9,9 C8.448,9 8,8.552 8,8 C8,7.448 8.448,7 9,7 C9.552,7 10,7.448 10,8",
    id: "Fill-3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.1856b998c8263f29297d9166cb1759f5.svg";
export { ForwardRef as ReactComponent };